import styled from 'styled-components';
import { formatCustomColor } from '../../../componentsThemeMap.js';
import '../../Link/index.js';
import { jsx } from 'react/jsx-runtime';
import { Link } from '../../Link/Link.js';
const InlineHyperLink = ({
  dataQa,
  target = '_self',
  foregroundInlineLink = 'blue60'
} = {}) => {
  return function hyperLink(node, children) {
    return children ? /*#__PURE__*/jsx(StyledInlineLink, {
      $color: foregroundInlineLink,
      "data-qa": dataQa,
      target: target,
      href: node?.data?.target?.fields?.file?.url || node.data.uri || '',
      children: children
    }) : null;
  };
};
const StyledInlineLink = styled(Link).attrs(p => ({
  style: {
    '--link-color': formatCustomColor(p.$color)
  }
}))`
  word-break: break-word;
  span {
    /* stylelint-disable-next-line declaration-no-important -- TODO Fix this */
    text-decoration: underline !important;
    color: var(--link-color);
  }
`;
export { InlineHyperLink, StyledInlineLink };
//# sourceMappingURL=InlineHyperLink.js.map
